import React from 'react';
import useAppContext from 'flow/hooks/useAppContext';
import UaePassButtonIcon, {
    uaePassButtonLang,
} from 'flow/components/icons/UaePassButtonIcon';

interface Props {
    onClick: () => void;
}

/* Design: white surface, #1D1D1A hairline border, 46px tall, inverted in dark mode. */
const FACE =
    'flex h-[46px] w-full cursor-pointer items-center justify-center gap-[8px] rounded-[4px] border-[1.5px] border-solid border-[#1D1D1A] bg-white p-0 text-[#1D1D1A] select-none dark:border-white dark:bg-[#1D1D1A] dark:text-white';

/* darken-* is invisible on the dark surface, so dark mode brightens instead. */
const STATES =
    'hover:darken-10 active:darken-20 dark:hover:brighten-10 dark:active:brighten-20';

const UaePassLoginButton: React.FC<Props> = ({ onClick }) => {
    const { i18next } = useAppContext();

    const lang =
        i18next.language === uaePassButtonLang.AR
            ? uaePassButtonLang.AR
            : uaePassButtonLang.EN;
    const label = i18next.t('uaepass.signin.button', 'Sign in with UAE PASS');

    return (
        <button
            type="button"
            onClick={onClick}
            aria-label={label}
            dir={lang === uaePassButtonLang.AR ? 'rtl' : 'ltr'}
            className={`${FACE} ${STATES} focus-ring`}
        >
            <UaePassButtonIcon label={label} lang={lang} />
        </button>
    );
};

export default UaePassLoginButton;
